/* *@Description: 导出下载中心 *@ComponentAuthor: xiejian *@Date: 2020-05-09 */
<template>
  <div class="mw-tab">
    <el-dialog :title="isImput ? $lang('导入文件下载') : $lang('导出文件下载')" :visible="showDownloadExport" @close="close" @opened="opened">
      <avue-crud
        class="box-list"
        ref="paramsChild"
        :data="tableList"
        :option="listOpt"
        :page="page"
        :table-loading="loading"
        @size-change="sizeChange"
        @current-change="currentChange"
        @search-reset="resetList"
        @search-change="searchChange"
      >
        <template slot="menuLeft">
          <slot name="menuChild"></slot>
        </template>
        <template slot="search">
          <slot name="searchChild"></slot>
        </template>
        <template slot="taskName" slot-scope="{ row }">
          {{ row.modelName }}
        </template>
        <template slot="operation" slot-scope="{ row }">
          <el-button
            class="row-icon"
            type="text"
            icon="iconfont iconbiaodan-xiazai"
            v-if="row.status === 2"
            :title="$lang('下载')"
            @click="downloadMethed(row)"
          >
          </el-button>
          <slot name="operationChild"></slot>
        </template>
      </avue-crud>
    </el-dialog>
  </div>
</template>
<script>
import mixin from '@mixins/mixin'
import { RESPONSE_CODE } from '@public/http/config'
import { commonFun } from '@public/utils/common'
import fetch from '@public/http/request'

const dateRange = commonFun.GetTodayDate()
export default {
  props: {
    showDownloadExport: {
      type: Boolean,
      default: false
    },
    remoteUrl: {
      type: String,
      default: ``
    },
    isImput: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixin],
  data() {
    return {
      formData: {
        startTime: dateRange[0],
        endTime: dateRange[1]
      },
      timer: null,
      isShowFirst: false
    }
  },
  methods: {
    // avue-查询方法
    async searchFun(params, current, flag) {
      if (!flag) {
        this.loading = true
      }
      if (!params && this.$refs.hasOwnProperty('paramsChild')) {
        params = this.rangHandle(this.$refs.paramsChild.searchForm)
      }
      if (current) {
        this.page.current = current
      }
      const param = this.searchFunParamsHandle(params)
      if (param === false) {
        this.loading = false
        return
      }
      param.userId = this.$store.state.base.user.id
      param.networkCode = this.$store.state.base.user.networkCode
      const timeState = setTimeout(() => {
        if (this.loading) this.loading = false
      }, 60000)
      try {
        const res = await fetch.post(this.remoteUrl, param, { timeout: 60 * 1000 })
        clearTimeout(timeState)
        this.loading = false
        this.pageLoading = false
        if (res.code === RESPONSE_CODE.SUCCESS || res.code === '1') {
          if (this.usePagination) {
            this.tableList = res.data.list
            this.page.total = res.data.total || 0
            this.page.current = res.data.pageNum || 1
          } else {
            this.tableList = this.formatList ? this.formatList(res.data) : res.data || []
          }
          this.searchAfterFun()
        } else {
          this.$message.error(res.msg)
          clearInterval(this.timer)
        }
      } catch (error) {
        console.error('searchFun::error', error)
        clearTimeout(timeState)
        clearInterval(this.timer)
        this.loading = false
        this.pageLoading = false
      }
    },
    async downloadMethed(row) {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = row.downUrl
      elink.setAttribute('download', this.$lang(row.fileName) + '.xls')
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
    opened() {
      this.searchFun()
      this.timer = setInterval(() => {
        this.searchFun(null, null, true)
      }, 10 * 1000)
    },
    close() {
      clearInterval(this.timer)
      this.$emit('update:showDownloadExport', false)
    }
  },
  computed: {
    listOpt() {
      const self = this
      return {
        pagination: true,
        menu: false,
        addBtn: false,
        searchExpand: false,
        tableHeight: 300,
        headerAlign: 'center',
        align: 'center',
        column: [
          {
            label: '开始时间',
            prop: 'startTime',
            search: true,
            hide: true,
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            searchClearable: false,
            searchDefault: dateRange[0],
            relationProps: ['endTime'],
            pickerOptions: {
              disabledDate: time => {
                const space = 60 * 24 * 3600 * 1000
                const minTime = new Date().getTime() - space
                const maxTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
                return time.getTime() < minTime || time.getTime() > maxTime
              }
            },
            change({ value }) {
              self.formData.startTime = value
            }
          },
          {
            label: '结束时间',
            prop: 'endTime',
            search: true,
            hide: true,
            type: 'datetime',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            searchClearable: false,
            searchDefault: dateRange[1],
            pickerOptions: {
              disabledDate: time => {
                const space = 30 * 24 * 3600 * 1000
                let { startTime } = self.formData
                startTime = startTime && new Date(new Date(startTime).toLocaleDateString()).getTime()
                const startTimes = startTime || new Date().getTime() - space
                const minTime = startTimes === dateRange[0] ? new Date(startTimes).getTime() : new Date(startTimes).getTime()
                const maxTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
                return time.getTime() < minTime || time.getTime() > maxTime
              }
            },
            change: ({ value }) => {
              self.formData.endTime = value
            }
          },
          {
            label: this.isImput ? '导入时间' : '导出时间',
            prop: 'createTime',
            minWidth: 120
          },
          {
            label: '模块名称',
            prop: 'modelName',
            minWidth: 120,
            formatter: ({ modelName }) => {
              if (!modelName) return
              return modelName.replace(/\(.*\)/g, '')
            }
          },
          {
            label: '任务名称',
            prop: 'taskName',
            minWidth: 120,
            slot: true
          },
          {
            label: '状态',
            prop: 'statusText',
            formatter: row => {
              const map = {
                0: `<i class="el-icon-loading"></i> ${row.statusText}`,
                1: `<i class="el-icon-loading"></i> ${row.statusText}`,
                2: `<i class="dot active"></i> ${row.statusText}`,
                3: `<i class="dot"></i> ${row.statusText}`,
                4: `<i class="dot"></i> ${row.statusText}`,
                5: `<i class="dot red"></i> ${row.statusText}`,
                6: `<i class="dot red"></i> ${row.statusText}`
              }
              return map[row.status]
            }
          },
          {
            label: '操作',
            prop: 'operation',
            hide: this.isImput,
            slot: true
          }
        ]
      }
    }
  }
}
</script>
